module.exports = __webpack_public_path__ + "static/media/truck.6bd382fa.png";